import IconGlyph from '@/bit/components/components.icon-glyph';
import { COLOR_DICTIONARY } from '@gcloud-npm/utils.enums.colors';

function Footer({ cyData }) {
  return (
    <div className="footer" data-cy={cyData}>
      <IconGlyph
        id="telefonica-reducido"
        alt="telefonica-reducido"
        kind="m"
        color={COLOR_DICTIONARY.BLUEB}
        layoutSize={{ width: 140 }}
        cyData={`${cyData}__icon`}
      />
      <style jsx>
        {`
          .footer {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 16px 0 32px 0;
          }
        `}
      </style>
    </div>
  );
}
export default Footer;
